import { makeMemberQuery } from "@web-monorepo/fetchers";

export const useSessionFetcher = makeMemberQuery({
  fetcherName: "toolkitSessionFetcher",
  path: "/api/session",
  query: {
    includeExtras: "mqttChannels,metaData",
  },
  dontThrowOnStatusCodes: [401],
});
